/**
 * 完整库引用
 * by 13
 */

import affix from '../affix/index';
import alert from '../alert/index';
import avatar from '../avatar/index';
import backTop from '../back-top/index';
import badge from '../badge/index';
import breadcrumb from '../breadcrumb/index';
import button from '../button/index';
import card from '../card/index';
import carousel from '../carousel/index';
import cascader from '../cascader/index';
import checkbox from '../checkbox/index';
import collapse from '../collapse/index';
import dataTable from '../data-table/index';
import datePicker from '../date-picker/index';
import dropdown from '../dropdown/index';
import form from '../form/index';
import { col, row } from '../grid/index';
import icon from '../icon/index';
import inputNumber from '../input-number/index';
import input from '../input/index';
import { layout, sider, header, content, footer } from '../layout/index';
import menu from '../menu/index';
// import message from '../message/index';
import modal from '../modal/index';
import morePanel from '../more-panel/index';
// import notification from '../notification/index';
import pagination from '../pagination/index';
import popconfirm from '../popconfirm/index';
import popover from '../popover/index';
import { progressLine, progressCircle } from '../progress/index';
import radio from '../radio/index';
import rate from '../rate/index';
import select from '../select/index';
import slider from '../slider/index';
import spin from '../spin/index';
import { steps, step } from '../steps/index';
import vSwitch from '../switch/index';
import tabs from '../tabs/index';
import tag from '../tag/index';
import timePicker from '../time-picker/index';
import timeline from '../timeline/index';
import tooltip from '../tooltip/index';
import transfer from '../transfer/index';
import treeSelect from '../tree-select/index';
import tree from '../tree/index';
import upload from '../upload/index';
export {
  affix,
  alert,
  avatar,
  backTop,
  badge,
  breadcrumb,
  button,
  card,
  carousel,
  cascader,
  checkbox,
  collapse,
  dataTable,
  datePicker,
  dropdown,
  form,
  row,
  col,
  icon,
  inputNumber,
  input,
  layout,
  sider,
  header,
  content,
  footer,
  menu,
  // message,
  modal,
  morePanel,
  // notification,
  pagination,
  popconfirm,
  popover,
  progressLine,
  progressCircle,
  radio,
  rate,
  select,
  slider,
  spin,
  steps,
  step,
  vSwitch,
  tabs,
  tag,
  timePicker,
  timeline,
  tooltip,
  transfer,
  treeSelect,
  tree,
  upload
};



// WEBPACK FOOTER //
// ./ui/vue-beauty/src/components/index/index.js